import { render, staticRenderFns } from "./CertificateLayout.vue?vue&type=template&id=37996ad4&scoped=true&"
import script from "./CertificateLayout.vue?vue&type=script&lang=js&"
export * from "./CertificateLayout.vue?vue&type=script&lang=js&"
import style0 from "./CertificateLayout.vue?vue&type=style&index=0&id=37996ad4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37996ad4",
  null
  
)

export default component.exports